import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../../loading/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/button/style/index.js
// module id = 66
// module chunks = 0